// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"86ebfad1e69d81c4ed72","655":"826483c2578a3c067dcd"}[chunkId] + ".js";
};